/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a function, not a component. */
import type { CalendarEvent } from '@ilamy/calendar';
import dayjs from 'dayjs';

import type { SchedulerItem } from './scheduler.types.js';

export function toCalendarEvent<TPayload>(item: SchedulerItem<TPayload>): CalendarEvent {
  const endTime = item.end.getTime() <= item.start.getTime() ? item.start : item.end;
  return {
    id: item.id,
    title: String(item.id),
    start: dayjs(item.start),
    end: dayjs(endTime),
    allDay: item.allDay,
    resourceId: item.resourceId,
    data: { payload: item.payload },
  };
}
